export default __webpack_public_path__ + "static/media/5.20bfea22.jpg";